import { genUID as genAlphaNumeric } from '@frontend/design-system';

export function genUID(): string {
  return genAlphaNumeric() + '-' + genAlphaNumeric();
}

/**
 * Get the prefix for the default category UUID.
 */
export function getPrefixForDefaultCategoryUUID(): string {
  return 'defcat';
}

/**
 * Generate a new default category ID for the categorized options field.
 */
export function genUUIDForDefaultCategory() {
  return `${getPrefixForDefaultCategoryUUID()}-${genAlphaNumeric()}`;
}
